module.exports = __webpack_public_path__ + "img/icon-xx.dcfe82e2.svg";